import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Trophy, Star, Target } from 'lucide-react';
import { fmtDateNo } from '../utils/dateFormat';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const ClubRecordsCard = () => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${API_BASE}/api/merkeskyting/records`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setRecords(r.data.records || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return null;
  if (!records || records.length === 0) return null;

  const top = records.slice(0, expanded ? records.length : 3);

  return (
    <div className="bg-gradient-to-br from-purple-600/20 via-indigo-600/10 to-blue-600/20 border border-purple-500/40 rounded-2xl p-5 shadow-lg" data-testid="club-records-card">
      <div className="flex items-start gap-3 mb-3">
        <div className="p-2 bg-purple-500/30 rounded-xl">
          <Star className="w-6 h-6 text-purple-300" />
        </div>
        <div className="flex-1">
          <p className="text-purple-300 text-xs font-bold uppercase tracking-wider">Klubbrekorder – Merkeskyting</p>
          <p className="text-white text-lg font-black">Beste enkeltserier</p>
        </div>
      </div>

      <div className="space-y-2">
        {top.map((r, i) => (
          <div key={`${r.discipline_key}:${r.variant_key}`} className="bg-black/30 rounded-xl p-3 flex items-center gap-3">
            <Trophy className="w-5 h-5 text-yellow-400 flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-white text-sm font-bold truncate">{r.discipline_name} – {r.variant_name}</p>
              <p className="text-purple-200 text-xs truncate">{r.member_name} • {fmtDateNo(r.result_date)}</p>
            </div>
            <div className="text-right flex-shrink-0">
              <p className="text-yellow-400 font-black text-lg leading-none">{r.score}</p>
              <p className="text-gray-400 text-[10px]">{r.unit_label}</p>
            </div>
          </div>
        ))}
      </div>

      {records.length > 3 && (
        <button
          onClick={() => setExpanded(!expanded)}
          className="mt-3 text-xs text-purple-300 hover:text-purple-200 font-medium"
          data-testid="records-toggle"
        >
          {expanded ? 'Skjul' : `Vis alle ${records.length} rekorder →`}
        </button>
      )}
    </div>
  );
};

export default ClubRecordsCard;
